import styled from "@emotion/styled";

import { DrawerCard, DrawerCardHeader, DrawerCardTitle } from "~/components/common/drawer/styles";

import { DynamicContentShareWidget, DynamicDrawer } from "./dynamics";

export const StyledDynamicDrawer = styled(DynamicDrawer)`
  ${DrawerCard} {
    position: relative;

    inline-size: 100%;
    padding-block: 20px 32px;
    padding-inline: 20px;
  }

  ${DrawerCardHeader} {
    margin-block-end: 25px;
  }

  ${DrawerCardTitle} {
    inline-size: 100%;

    font-weight: unset;
    font-size: 19px;
    line-height: 23px;
    text-align: center;
  }
`;

export const StyledDynamicContentShareWidget = styled(DynamicContentShareWidget)`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 32px 24px;
  justify-items: center;
  align-items: center;
`;
